import EmoticonAnnoyed from '@helsenorge/designsystem-react/components/Icons/EmoticonAnnoyed';
import EmoticonDelighted from '@helsenorge/designsystem-react/components/Icons/EmoticonDelighted';
import EmoticonDisappointed from '@helsenorge/designsystem-react/components/Icons/EmoticonDisappointed';
import EmoticonHappy from '@helsenorge/designsystem-react/components/Icons/EmoticonHappy';
import EmoticonMeh from '@helsenorge/designsystem-react/components/Icons/EmoticonMeh';
export const getIcon = (value) => {
    switch (value) {
        case '5':
            return EmoticonDelighted;
        case '4':
            return EmoticonHappy;
        case '3':
            return EmoticonMeh;
        case '2':
            return EmoticonDisappointed;
        case '1':
            return EmoticonAnnoyed;
    }
};
